import React from 'react';

interface SummonerHeaderProps {
  gameName: string;
  tagLine: string;
  profileIconId: number;
  summonerLevel: number;
  region: string;
  ddragonVersion: string;
  onUpdate: () => void;
  updating: boolean;
  cached?: boolean;
}

const SummonerHeader: React.FC<SummonerHeaderProps> = ({
  gameName,
  tagLine,
  profileIconId,
  summonerLevel,
  region,
  ddragonVersion,
  onUpdate,
  updating,
  cached,
}) => {
  const iconUrl = `https://ddragon.leagueoflegends.com/cdn/${ddragonVersion}/img/profileicon/${profileIconId}.png`;

  return (
    <div className="summoner-header">
      <div className="summoner-header-inner">
        <div className="profile-icon-wrapper">
          <img src={iconUrl} alt="Profile Icon" className="profile-icon" />
          <span className="summoner-level">{summonerLevel}</span>
        </div>
        <div className="summoner-identity">
          <h1 className="summoner-name">
            {gameName}
            <span className="summoner-tag">#{tagLine}</span>
          </h1>
          <span className="summoner-region">{region.toUpperCase()}</span>
        </div>
        <button
          className={`update-btn ${updating ? 'update-btn-loading' : ''}`}
          onClick={onUpdate}
          disabled={updating}
        >
          {updating ? 'Updating...' : 'Update'}
        </button>
      </div>
    </div>
  );
};

export default SummonerHeader;
